import HttpService from '@/services/http/http.service';
import {
    ArenaTeamStatisticsViewModel,
    CharacterStatisticViewModel,
    MultiRealmSpecificRequest,
    SelectTopArenaTeamsRequest,
    TopBattleRoyaleViewModel,
    TopHKRequest,
    TopHKViewModel,
    TopVotersViewModel,
    UserStatisticsViewModel
} from '@/types/apiServerContract';

const API_PATH = 'statistics/';

export class StatisticsApi {
    public static async GetUserStatistics(): Promise<UserStatisticsViewModel> {
        return HttpService.Get<UserStatisticsViewModel>(API_PATH + 'GetUserStatistics');
    }

    public static async GetCharacterStatistics(request: MultiRealmSpecificRequest): Promise<CharacterStatisticViewModel> {
        return HttpService.Post<CharacterStatisticViewModel>(API_PATH + 'GetCharacterStatistics', request);
    }

    public static async GetTopHkPlayers(request: TopHKRequest): Promise<TopHKViewModel> {
        return HttpService.Post<TopHKViewModel>(API_PATH + 'GetTopHkPlayers', request, undefined, true);
    }

    public static async GetBattleRoyaleStatistics(request: TopHKRequest): Promise<TopBattleRoyaleViewModel> {
        return HttpService.Post<TopBattleRoyaleViewModel>(API_PATH + 'GetBattleRoyaleStatistics', request, undefined, true);
    }

    public static async GetKingOfTheHillStatistics(request: TopHKRequest): Promise<TopHKViewModel> {
        return HttpService.Post<TopHKViewModel>(API_PATH + 'GetKingOfTheHillStatistics', request, undefined, true);
    }

    public static async GetTopArenaTeams(request: SelectTopArenaTeamsRequest) {
        return HttpService.Post<ArenaTeamStatisticsViewModel>(API_PATH + 'GetTopArenaTeams', request);
    }

    public static async GetTopVoters(): Promise<TopVotersViewModel> {
        return HttpService.Get<TopVotersViewModel>(API_PATH + 'GetTopVoters');
    }
}
